import EFPicture from '@elem/compCommon/EFPicture';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EfSpec from '@elem/ui/ef-spec';

export default function ChargingTimes() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('theProduct.ChargingTimes');
    const { locale } = useRouter();

    const tips_items = new Array(2).fill(1);

    // eu 6 站去掉最后 DPU css 隐藏
    const data = [
        [t('table_1_1'), t('table_1_2'), t('table_1_3'), t('table_1_4'), t('table_1_5'), t('table_1_6'), t('table_1_7'), t('table_1_8')],
        [t('table_2_1'), t('table_2_2'), t('table_2_3'), t('table_2_4'), t('table_2_5'), t('table_2_6'), t('table_2_7'), t('table_2_8')],
        [t('table_3_1'), t('table_3_2'), t('table_3_3'), t('table_3_4'), t('table_3_5'), t('table_3_6'), t('table_3_7'), t('table_3_8')],
        [
            t('table_4_1'),
            t('table_4_2'),
            t('table_4_3'),
            t('table_4_4'),
            t('table_4_5'),
            t('table_4_6'),
            t('table_4_7'),
            t('table_4_8'),
            // [{ text: t('table_4_2'), memo: t('table_4_2_tip') }],
            // [{ text: t('table_4_3'), memo: t('table_4_3_tip') }],
            // [{ text: t('table_4_4'), memo: t('table_4_4_tip') }],
            // [{ text: t('table_4_5'), memo: t('table_4_5_tip') }],
            // [{ text: t('table_4_6'), memo: t('table_4_6_tip') }],
            // [{ text: t('table_4_7'), memo: t('table_4_7_tip') }],
            // [{ text: t('table_4_8'), memo: t('table_4_8_tip') }],
        ],
        [t('table_5_1'), t('table_5_2'), t('table_5_3'), t('table_5_4'), t('table_5_5'), t('table_5_6'), t('table_5_7'), t('table_5_8')],
        [t('table_6_1'), t('table_6_2'), t('table_6_3'), t('table_6_4'), t('table_6_5'), t('table_6_6'), t('table_6_7'), t('table_6_8')],
    ];

    const IMGS = [
        'https://websiteoss.ecoflow.com/upload/image/1731933316761/times_1.png',
        'https://websiteoss.ecoflow.com/upload/image/1731933317366/times_2.png',
        'https://websiteoss.ecoflow.com/upload/image/1732091681832/times_3.png',
        'https://websiteoss.ecoflow.com/upload/image/1731933316935/times_4.png',
        'https://websiteoss.ecoflow.com/upload/image/1731933317536/times_5.png',
        // 'https://websiteoss.ecoflow.com/upload/image/1731933317774/times_6.png',
        'https://websiteoss.ecoflow.com/website/upload/2022/3/7/DELTA%20PRO%20related_1646639685749.png',
        'https://websiteoss.ecoflow.com/upload/image/1731933317984/times_7.png',
    ];

    return (
        <div className={`${styles.TheComp} sp-125w-common`}>
            <EfSpec />
            <div className="info">
                <p className="title">{t('title')}</p>
            </div>
            <div className="wrapper">
                <table className="table">
                    <tbody className="tbody">
                        {data?.map((tr: any, k: number) => (
                            <tr className="tr" key={k}>
                                {tr?.map((td: any, m: number) => (
                                    <td className="td" key={`${k}_${m}`}>
                                        {k === 0 && m !== 0 && (
                                            <div className="cell-img">
                                                <EFPicture src={IMGS[m - 1]} alt={td} />
                                            </div>
                                        )}
                                        {Array.isArray(td) ? (
                                            <ul className="cell-ul">
                                                {td.map((list: any, n: number) => (
                                                    <li className="cell-li" key={`${k}_${m}_${n}`}>
                                                        {list?.text && <p className="cell-text">{list.text}</p>}
                                                        {list?.memo && <p className="cell-memo">{list.memo}</p>}
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <p className="cell-text">{td}</p>
                                        )}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="tips-box">
                {tips_items.map((item: any, index: number) => (
                    <p key={index} className="tip">
                        {t(`tip_${index + 1}`)}
                    </p>
                ))}
            </div>
        </div>
    );
}
